<template>
<div class="resetpass-form">
  <h3 class="title">{{$t('register')}}</h3>
  <p class="tips">{{$t('Please_fill_in_the_true_and_valid_information')}}</p>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    hide-required-asterisk
    v-loading="loading"
  >
<!--    <p>{{$t('name')}}</p>-->
    <p>{{$t('family_name')}}</p>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item
          prop="lastName"
        >
          <el-input
            v-emoji
            :placeholder="$t('family_name')"
            v-model="form.lastName"
            name="username"
            maxlength="30"
            class="w-full">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          prop="familyName"
        >
          <el-input
            v-emoji
            :placeholder="$t('Register.lastName')"
            v-model="form.familyName"
            name="username"
            maxlength="30"
            class="w-full">
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item
      :label="$t('email')"
      prop="email"
    >
      <el-input
        :placeholder="$t('please_input')"
        v-model="form.email"
        name="email"
        class="w-full">
      </el-input>
    </el-form-item>
    <el-form-item
      :label="$t('mobile_phone')"
      prop="phone"
      class="no-need-border-radiu"
    >
      <el-input
        :placeholder="$t('please_input')"
        v-model="form.phone"
        name="phone"
        @input="phoneInputHandle"
        class="w-full">
        <el-select
          style="width: 100px;"
          slot="prepend"
          :placeholder="$t('root.selectPls')"
          v-model="phoneTitle"
          @change = "changePhone"
          filterable
        >
          <el-option
            v-for="option in phoneList"
            :key="option.value"
            :label="option.label"
            :value="option.label"
          >
            <span>{{`${option.label} ${option.description}`}}</span>
          </el-option>
        </el-select>
      </el-input>
    </el-form-item>
    <!-- PC端: 验证方式select + 验证码input + 发送按钮 一行展示 -->
    <el-form-item
      v-if="!realMobile"
      :label="$t('Verification_mode')"
      prop="veriCode"
    >
      <div class="code-row">
        <el-select
          class="code-row-select"
          v-model="veriCodeType"
          :disabled="phoneTitle != '+86'"
        >
          <el-option
            v-for="option in availableVeriCodeTypeList"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          >
          </el-option>
        </el-select>
        <el-input
          :placeholder="$t('Partner.inputVer')"
          v-model="form.veriCode"
          maxlength="7"
          class="code-row-input"
        ></el-input>
        <el-button
          class="code-row-btn"
          type="primary"
          :loading="codeLoading"
          :disabled="isCountDownStart || codeLoading"
          @click="getCode"
        >
          <span v-if="!isCountDownStart">{{$t('Send_verification_code')}}</span>
          <span v-else>{{countDown}}s</span>
        </el-button>
      </div>
    </el-form-item>
    <!-- 移动端: 验证方式独立一行 + 验证码输入框与发送按钮并排 -->
    <template v-if="realMobile">
      <el-form-item :label="$t('Verification_mode')">
        <el-select
          style="width: 100%"
          v-model="veriCodeType"
          :disabled="phoneTitle != '+86'"
        >
          <el-option
            v-for="option in availableVeriCodeTypeList"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('Verification_Code')"
        prop="veriCode"
      >
        <div class="code-inline-mobile">
          <el-input
            :placeholder="$t('Partner.inputVer')"
            v-model="form.veriCode"
            maxlength="7"
            class="code-inline-input"
          ></el-input>
          <el-button
            class="code-inline-btn"
            type="primary"
            :loading="codeLoading"
            :disabled="isCountDownStart || codeLoading"
            @click="getCode"
          >
            <span v-if="!isCountDownStart">{{$t('Send_verification_code')}}</span>
            <span v-else>{{countDown}}s</span>
          </el-button>
        </div>
      </el-form-item>
    </template>
    <el-form-item
      :label="$t('password')"
      prop="newPsw"
      :show-message="false"
      class="has-text-content"
    >
      <el-input
        v-model="form.newPsw"
        show-password
        maxlength="20"
        :placeholder="$t('please_input')"
      ></el-input>
      <p class="pass-strong-level one-level"
         :class="{
                          on: oneLevelFlag == true,
                         nopass: oneLevelFlag == false,
                     }"
      >
        <span class="circle pass-strong-circle"></span>
        <span>{{$t('limitRegistPassOneStep')}}</span>
      </p>
      <p class="pass-strong-level two-level"
         :class="{
                       on: twoLevelFlag,
                            nopass: twoLevelFlag == false,
                       }"
      >
        <span class="circle pass-strong-circle"></span>
        <span>{{$t('limitRegistPassTwoStep')}}</span>
      </p>
    </el-form-item>
    <el-form-item
      prop="rePsw"
      :label="$t('Register.rePswText')"
    >
      <el-input
        type="password"
        v-model="form.rePsw"
        show-password
        maxlength="20"
        :placeholder="$t('Register.rePswText')"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="showInviteCode"
      :label="$t('invite_code') + '('+ $t('optional') +')'"
      prop="token"
    >
      <el-input
        :placeholder="$t('please_input')"
        v-model="form.token"
        maxlength="50"
        class="w-full"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <vs-button
        class="w-full mt-6"
        color="primary"
        type="filled"
        size="large"
        :disabled="loading"
        @click="registHandle"
      >
        <span v-if="loading"><i class="el-icon-loading"></i> </span>
        {{$t('register')}}
      </vs-button>
    </el-form-item>
  </el-form>
  <p class="center">
    {{$t('Already_have_an_account')}}?
    <span
      @click="toLogin"
      class="theme-color pointer">{{$t('To_log_in')}}</span>
  </p>
</div>
</template>

<script>
import { setLocalStorage } from '@/utils/common';
import { passFisrtStrong, passSecondStrong, validatEmail,strongPwd,limitNumber,isMobile } from "@/utils/validate";
import { RegisterPost,getSendVerEmail } from '@/api/user'
import { getDictListByType } from "@/api/home";
import { getDictByTypeAsync } from '@/utils/cacheService';
import { mapGetters } from 'vuex';
export default {
  name: "registForm",
  data() {
    var validateUserName = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        callback(new Error(this.$t('please_enter')));
      } else {
        if(SPECIALCHAR_RULE.test(value)){
          callback(new Error(this.$t('Usernames_are_not_allowed_to_contain_special_characters')));
        }else {
          callback();
        }
      }
    };
    let _this = this;
    var validateEmailCurrent = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        callback(new Error(_this.$t('please_input_your_email')));
      } else {
        if(!validatEmail(value)){
          callback(new Error(_this.$t('Please_enter_the_email_address_in_the_correct_format')));
        }else {
          callback();
        }
      }
    };

    var validatePhone = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        callback(new Error(_this.$t('phoneEmtpyTips')));
      } else {
        if (!isMobile(value, _this.phoneTitle)) {
          callback(new Error(_this.$t('Register.errorPhon')));
        } else {
          callback();
        }
      }
    };

    var validatePass = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        callback(new Error(_this.$t('Register.notpassword')));
      } else {
        if(!strongPwd(value)){
          callback(new Error(_this.$t('Register.passwordDes')));
        }else {
          callback();
        }
      }
    };
    var validateRePsw = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        callback(new Error(_this.$t('Register.rePswText')));
      } else {
        if(value !== _this.form.newPsw){
          callback(new Error(_this.$t('Register.notrepassword')));
        }else {
          callback();
        }
      }
    };
    return {
      phoneTitle: '+86',

      veriCodeTypeList: [
        { label: _this.$t('mobile_phone'), value: 1 },
        { label: _this.$t('email'), value: 2 },
      ],
      form:{
        familyName: '',
        lastName: '',
        email: '',
        phone: '',
        veriCode: '',
        newPsw: '',
        rePsw: '',
        token: '',
      },
      rules:{
        familyName: [
          // { required: true, message: _this.$t('User.nameNullMessage'), trigger: 'blur' },
          { validator: validateUserName, trigger: ['blur', 'change'] },
        ],
        lastName: [
          // { required: true, message: _this.$t('Register.errorFirstName'), trigger: 'blur' }
          { validator: validateUserName, trigger: ['blur', 'change'] },
        ],
        email: [
          // 另外引入邮箱的正则验证
          {
            validator: validateEmailCurrent,
            trigger: 'blur'
          },
        ],
        phone: [
          { validator: validatePhone, trigger: 'blur' },
          /*{ required: true, message: _this.$t('Please_enter_the_phone_number'), trigger: 'blur' }*/
        ],
        veriCode: [
          { required: true, message: _this.$t('Partner.inputVer'), trigger: 'blur' }
        ],
        newPsw: [
          { validator: validatePass, trigger: 'blur' }
        ],
        rePsw: [
          { validator: validateRePsw, trigger: 'blur' }
        ],
      },
      phoneList: [],
      countDown: 60,
      isCountDownStart: false, // 是否开始倒计时
      querys: null,
      loading: false,
      codeLoading: false,
      veriCodeType:2,
      showInviteCode: true
    }
  },
  created(){
    this.querys = this.$route.query;
    if (this.querys.token) {
      this.form.token = this.querys.token;
      this.showInviteCode = false;
    }
    this.getPhoneList();
  },
  computed: {
    ...mapGetters(['realMobile', 'smsVerificationEnabled']),
    availableVeriCodeTypeList(){
      return this.smsVerificationEnabled
        ? this.veriCodeTypeList
        : this.veriCodeTypeList.filter((option) => option.value !== 1);
    },
    verificationType(){
      return this.smsVerificationEnabled ? this.veriCodeType : 2;
    },
    oneLevelFlag(){
      if(this.form.newPsw !== ''){
        return passFisrtStrong(this.form.newPsw);
      }
    },
    twoLevelFlag(){
      if(this.form.newPsw !== ''){
        return passSecondStrong(this.form.newPsw);
      }
    }
  },
  methods: {
    setLocalStorage,
    getCode(){
      if (this.codeLoading || this.isCountDownStart) return;
      const fieldToValidate = this.verificationType == 1 ? 'phone' : 'email';
      this.$refs.form.validateField(fieldToValidate, (error) => {
        if(!error){
          this.codeLoading = true;
          getSendVerEmail({
            phone: this.form.phone,
            nationCode: this.phoneTitle,
            email: this.form.email,
            verType:this.verificationType
          }).then((res) => {
            this.isCountDownStart = true;
            this.countDown = 60;
            let countDownId = setInterval(() => {
              if (this.countDown <= 0) {
                clearInterval(countDownId);
                this.isCountDownStart = false;
                this.countDown = 60;
                return;
              }
              this.countDown -= 1;
            }, 1000);
          }).finally(() => {
            this.codeLoading = false;
          })
        }
      })
    },
    getPhoneList(){
      getDictByTypeAsync(getDictListByType, 'phoneList').then((data) => {
        this.phoneList = data;
      });
    },
    registHandle() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if(valid){
          this.loading = true;
          let parmas = {
            password: this.$md5(this.form.rePsw.trim()),
            phone: this.form.phone.trim(),
            email: this.form.email.trim(),
            firstName: this.form.lastName.trim(),
            lastName: this.form.familyName.trim(),
            nationCode: this.phoneTitle,
            phoneVerCode: this.form.veriCode,
            verType: this.verificationType,
            token: this.form.token.trim()
            // nationality: this.form.nation,已经去掉了
          };
          if (this.querys) {
            parmas = Object.assign(this.querys, parmas);
          }
          RegisterPost(parmas).then((res) => {
            localStorage.setItem('token', res.data.token);
            this.setLocalStorage('userInfo', res.data.cust);

            this.$store.commit('setUserInfo', res.data.cust);
            this.setLocalStorage('custStatus', res.data.cust.custStatus);
            if(res.data.cust.custStatus == 1){
              this.$router.push({ name: 'perfectInfo' }).catch(() => {
                window.location.href = this.$router.resolve({ name: 'perfectInfo' }).href;
              });
            }else if (res.data.cust.custStatus == 10) {
              this.loading = false;
              this.$emit('regist-success');
            }
          }).catch((err) => {
            this.loading = false;
          })
        }else {
          // 滚动到第一个错误的表单项
          this.$nextTick(() => {
            const errorItem = this.$refs.form.$el.querySelector('.el-form-item.is-error');
            if (errorItem) {
              errorItem.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }
          });
          console.log('error validate');
        }
      });
    },
    toLogin(){
      this.$router.push({name: 'login'});
    },
    phoneInputHandle(){
      this.form.phone = limitNumber(this.form.phone);
    },
    changePhone(){
      if(this.smsVerificationEnabled && this.phoneTitle == '+86'){
        this.veriCodeType = 1;
      }else {
        this.veriCodeType = 2;
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.resetpass-form {
  /deep/ .el-input__inner {
    border: 1px solid #D8D6DE;
    border-radius: 5px;
  }
  /deep/ .el-form-item__content {
    line-height: 10px;
  }
  /deep/ .el-form-item {
    margin-bottom: 24px;
  }
  /deep/ .el-form-item__label {
    padding-bottom: 5px;
    line-height: 14px;
  }

  .text-p {
    margin-bottom: 7px;
    margin-top: 7px;
  }
  .tips {
    margin-bottom: 40px;
    margin-top: 10px;
  }
  .pass-strong-level {
    margin-top: 10px;
  }
  .code-row {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    .code-row-select {
      width: 110px;
      flex-shrink: 0;
    }
    .code-row-input {
      flex: 1;
      min-width: 0;
    }
    .code-row-btn {
      flex-shrink: 0;
      white-space: nowrap;
    }
  }
  .code-inline-mobile {
    display: flex;
    align-items: center;
    width: 100%;
    .code-inline-input {
      width: 60%;
      margin-right: 4%;
    }
    .code-inline-btn {
      width: 36%;
    }
  }
}
</style>
<style lang="scss">
.resetpass-form {
  .no-need-border-radiu {
    .el-input__inner {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
}
</style>
